import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  private baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  _addOrganization(payload: OrganizationRequest) {
    return this.http.post<any>(this.baseUrl + "users/organizations", payload);
  }

  _getOrganizationTypes() {
    return this.http.get<any>(this.baseUrl + "v1/teamstore/organizationtype/all");
  }

  _getALLOrganizationList(page: number, per_page: number, name?: string, type?: string, primaryColor?: string, secondarycolor?: string, state?: string, city?: string) {
    name = name ?? '';
    primaryColor = primaryColor ?? '';
    secondarycolor = secondarycolor ?? '';
    type = type ?? '';
    state = state ?? '';
    city = city ?? '';

    let params = new HttpParams()
      .set('name', name)
      .set('city', city)
      .set('id', '0')
      .set('order', 'asc')
      .set('per_page', per_page.toString())
      .set('page', page.toString())
      .set('type', type)
      .set('primaryColor', primaryColor)
      .set('secondarycolor', secondarycolor)
      .set('state', state);
    return this.http.get<any>(this.baseUrl + 'v1/teamstore/organizationList', { params: params, observe: 'response' });
  }

  _getOrganizationById(id: number) {
    return this.http.get<ApiResponse<Organization>>(this.baseUrl + "v1/teamstore/organizations/" + id);
  }

  _updateOrganization(payload: Organization) {
    console.log(payload, "payload");
    return this.http.post<any>(this.baseUrl + "v1/teamstore/organizations/edit", payload);
  }

  _getOrganizationOrderListt(OrganizationId: number, page: number, per_page: number) {
    let params = new HttpParams()
      .set('OrganizationId', OrganizationId.toString())
      .set('per_page', per_page.toString())
      .set('page', page.toString())
      .set('order', 'DatePlaced')
    return this.http.get<PaginatedResponse<any[]>>(this.baseUrl + 'v1/teamstore/organizationOrderList', { params: params, observe: 'response' });
  }

  _getOrganizationContactList(OrganizationId: number, page: number, per_page: number) {
    let params = new HttpParams()
      .set('OrganizationId', OrganizationId.toString())
      .set('per_page', per_page.toString())
      .set('page', page.toString());
    return this.http.get<PaginatedResponse<any[]>>(this.baseUrl + 'v1/teamstore/organizationContactList', { params: params, observe: 'response' });
  }

  // Artwork apis

  _addAtrwork(payload: ArtworkRequest) {
    return this.http.put<any>(this.baseUrl + "v1/teamstore/saveartwork", payload);
  }

  _fetchArtworks() {
    let params = new HttpParams()
      .set('per_page', 10)
      .set('page', 0);
    return this.http.get<PaginatedResponse<any[]>>(this.baseUrl + 'v1/teamstore/artworkList', { params: params, observe: 'response' });
  }

  _getArtWorById(id: number) {
    return this.http.get<ApiResponse<any>>(this.baseUrl + "v1/teamstore/artworks/" + id);
  }


  _marketDropDown() {
    return this.http.get<ApiResponse<any>>(this.baseUrl + "v1/teamstore/departments/all");
  }

  // drop down apis 

  _organizationDropdown(userId: number) {
    return this.http.get<ApiResponse<any>>(this.baseUrl + "v1/teamstore/user/organizations/" + userId);
  }

  _departmentsDropdown(userId: number, orgId: number) {
    return this.http.get<ApiResponse<any>>(`${this.baseUrl}v1/teamstore/user/departments/${userId}/${orgId}`);
    // return this.http.get<ApiResponse<any>>(this.baseUrl + "v1/teamstore/user/departments/" + userId + "/" + orgId);
  }

  _artworkDropdown(userId: number, deptId: number) {
    return this.http.get<ApiResponse<any>>(`${this.baseUrl}v1/teamstore/user/artworks/${userId}/${deptId}`);
  }

  _getOrganizationListByName(name?: string) {
    if (name == undefined) {
      name = ''
    }
    const params = new HttpParams().set('name', name);
    return this.http.get<ApiResponse<any>>(`${this.baseUrl}v1/teamstore/organizations/list`, { params: params });
  }

  _getHubspotDetails(hubspotDealId: any) {
    return this.http.get<ApiResponse<any>>(`${this.baseUrl}v1/teamstore/crm/${hubspotDealId}`);
  }

}



export interface ApiResponse<T> {
  statusCode: number;
  status: number;
  message: string;
  description: string | null;
  data: T;
  total_Records: number;
  exception: any | null;
}


export interface PaginatedResponse<T> {
  statusCode: number;
  status: number;
  message: string;
  description: string | null;
  data: T[];
  total_Records: number;
  exception: any | null;
}


export class OrganizationRequest {
  name: string;
  address: string;
  address1: string;
  city: string;
  state: string;
  zip: string;
  institutionTypeId: number;
  userId: any;
  PrimaryColorId: number;
  SecondaryColorId: number;
  AlternateColorIds?: any;
  vendorId: string;
}

export class Organization {
  id: number;
  name: string;
  address: string;
  address1: string;
  city: string;
  state: any;
  country: string;
  zip: string;
  department: any
  departmentId: number;
  institutionTypeId: number;
  userId: number;
  primaryColorId: number;
  primaryColorName: string;
  primaryColorHexcode: string;
  secondaryColorId: number;
  secondaryColorName: string;
  secondaryColorHexcode: string;
  alternateColorOneId: number;
  alternateColorOneName: string;
  alternateColorOneHexcode: string;
  alternateColorTwoId: number;
  alternateColorTwoName: string;
  alternateColorTwoHexcode: string;
  activeCampaignId: number;
  url: string;
  alias: string;
  institutionType: InstitutionType;
  organizationSettings: OrganizationSettings;
  alternateColorIds: any;
  alternateColorInfo: AlternateColorInfo[]
  vendorId: string
  organizationLogoUrl?: string;
}


export class AlternateColorInfo {
  id: number;
  name: string;
  hexCode: string;
}
export class InstitutionType {
  id: number;
  name: string;
  shortAbbreviation: string;
  longAbbreviation: string;
  mascotText: string;
  mascotId: number;
  athleticsURL: string;
  conference: string;
  nces: string;
  doe: any
  logo: any
}

export class OrganizationSettings {
  id: number;
  name: string;
  shortAbbreviation: string;
  longAbbreviation: string;
  mascotText: string;
  mascotId: number;
  athleticsURL: string;
  conference: string;
  nces: string;
  doe: any
}

export class ArtworkRequest {
  Id: number;
  OrganizationId: number;
  Description: string;
  Url: string;
  LocationIds: string;
  ColorIds: string;
  ServiceIds: string;
  Metadata: string;
  DepartmentId: number;
}


